import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import Pagination from "../../Pagination";
import Loader from "../../../img/Document scan.gif"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import { useParams } from "react-router";
import { studyEDCLupReportingServices } from "../../../APIServices/studyEDCLupReportingServices";
import TableProperties from "../../LUPManagement/LibraryManagement/TableProperties";

const ViewEDCLupDataset = ({ tableRef, onMouseDown, ids }) => {
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [columnList, setColumnList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [tableColumns, setTableColumns] = useState({});
  const [columnType, setColumnType] = useState("label");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (Number(pageNumber) - 1) * Number(itemsPerPage);
  const endIndex = startIndex + Number(itemsPerPage);
  let result = dataList?.slice(startIndex, endIndex) || [];
  let totalPage = Math.ceil(dataList?.length / itemsPerPage);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const { studyId } = useParams()

  const { toggle, setToggle } =
    UseToggle();

  const getEDCLupDatasetById = async (uniqueId) => {
    setLoader(true)
    let data = await studyEDCLupReportingServices.getEDCLupDatasetById(uniqueId, studyId, StudyMode);
    setColumnList(data?.data?.column || []);
    setDataList(data?.data?.row);
    setLoader(false)
  };

  useEffect(() => {
    if (ids?.uniqueId) {
      getEDCLupDatasetById(ids?.uniqueId);
    }
  }, [ids?.uniqueId]);

  const downloadCSV = () => {
    if (!columnList || !dataList) return;
    const headers = columnList?.map((col) =>
      columnType === "name" ? col.name : col.label
    );
    const rows = dataList?.map((row) =>
      columnList.map((col) => row?.[col?.name])
    );
    const csvArray = [headers, ...rows];
    const csvContent = csvArray
      .map((row) =>
        row
          .map((cell) =>
            typeof cell === "string" && cell.includes(",")
              ? `"${cell}"`
              : cell
          )
          .join(",")
      )
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${ids?.name}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadExcel = () => {
    if (!columnList || !result) return;
    const headers = columnList?.map((col) =>
      columnType === "name" ? col.name : col.label
    );
    const rows = dataList?.map((row) =>
      columnList?.map((col) => row?.[col?.name])
    );
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `${ids?.name}.xlsx`);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      `studyEDCLupDataset_${ids?.uniqueId}`,
      studyId
    );
    setTableColumns(data?.data || {});
  };

  useEffect(() => {
    getTablePropertiesData();
  }, []);

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.studyId = studyId;
        userData.type = `studyEDCLupDataset_${ids?.uniqueId}`;
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getTablePropertiesData();
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <Form.Select onChange={(e) => setColumnType(e.target.value)} value={columnType} style={{ width: 200 }}>
          <option value={"name"}>By Name</option>
          <option value={"label"}>By Label</option>
        </Form.Select>
        <div className="hstack gap-2">
          <button onClick={setToggle} className={`updateProfile`}>Table Properties</button>
          <button onClick={downloadCSV} className={`updateProfile`}>CSV Download</button>
          <button onClick={downloadExcel} className={`updateProfile`}>Excel Download</button>
        </div>
      </div>
      {loader ? (
        <div className="hstack justify-content-center"
          style={{ height: "calc(100vh - 181px)" }}>
          <img src={Loader} alt="Page Loader" />
        </div>
      ) : !ids?.uniqueId ? (
        <div className="hstack justify-content-center fw-bold text-muted"
          style={{ height: "calc(100vh - 181px)" }}>
          Not any field!
        </div>
      ) : dataList?.length === 0 ? (
        <NoDataFoundTable MSG={"Data Not Found!"} />
      ) :
        <>
          <div className="overflow-auto">
            <Table ref={tableRef} className="m-0 custom-table tableLibrary" hover striped>
              <thead className="position-sticky top-0">
                <tr>
                  {columnList?.map((col, index) =>
                    tableColumns[col?.name] ? null : (
                      <th
                        key={index}
                        style={{ cursor: "pointer" }}
                        onMouseDown={(e) => onMouseDown(e, index + 1)}
                      >
                        {columnType === "name" ? col.name : col.label}
                      </th>
                    )
                  )}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {result?.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columnList?.map((col, colIndex) =>
                      tableColumns[col?.name] ? null : (
                        <td key={colIndex}>{row?.[col.name]}</td>
                      )
                    )}
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="position-sticky bottom-0 start-0">
            <Pagination
              totalPage={totalPage}
              pageNumber={pageNumber}
              itemsPerPage={itemsPerPage}
              totalItems={dataList?.length}
              setPageNumber={setPageNumber}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </>
      }
      <TableProperties
        Show={!toggle}
        Hide={setToggle}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Table Properties"}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        buttonLoader={buttonLoader}
        columnList={columnList}
        updateTableProperties={updateTableProperties}
      />
    </>
  );
};

export default ViewEDCLupDataset;
